'use strict'

const get_ = require('lodash/get')
const result = require('folktale/result')
const maybe = require('folktale/maybe')

module.exports = (event, fallbackValue) =>
  maybe
    .fromNullable(get_(event, ['target', 'src']))
    .map(url => result.try(() => decodeURIComponent(url)).getOrElse(url))
    .getOrElse(fallbackValue)



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/getUrlFromEvent.js